import React, { useState, useEffect } from "react"
import withStyles from "react-jss"

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  svg: {
    // border: "1px solid hotpink",
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0,
  },
  rect: {
    // transition: "opacity 0.s ease-in-out",
  },
}

const BarViz = ({ classes, topColor, bottomColor }) => {
  const height = 200,
    width = 600,
    widthPadding = 10,
    heightPadding = 11,
    noOfCols = 6,
    barHeight = 10,
    barWidth = width / noOfCols - 2 * widthPadding

  const [x, setX] = useState([
    {
      pos: widthPadding,
      topBars: 1,
      bottomBars: 3,
    },
    {
      pos: width / 6 + widthPadding,
      topBars: 2,
      bottomBars: 5,
    },
    {
      pos: (2 * width) / 6 + widthPadding,
      topBars: 5,
      bottomBars: 2,
    },
    {
      pos: (3 * width) / 6 + widthPadding,
      topBars: 3,
      bottomBars: 1,
    },
    {
      pos: (4 * width) / 6 + widthPadding,
      topBars: 5,
      bottomBars: 4,
    },
    {
      pos: (5 * width) / 6 + widthPadding,
      topBars: 2,
      bottomBars: 2,
    },
  ])

  const getRandomNumber = (min = 1, max = 5) =>
    Math.floor(Math.random() * (max - min + 1)) + min

  useEffect(() => {
    const interval = setInterval(() => {
      setX((x) =>
        x.map((d) => ({
          ...d,
          topBars: getRandomNumber(),
          bottomBars: getRandomNumber(),
        }))
      )
    }, 130)
    return () => clearInterval(interval)
  }, [])

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0, 0, ${width}, ${height}`}
      preserveAspectRatio="xMidYMid meet">
      {x.map(({ pos, topBars }, i) => (
        <g className="top" key={i}>
          {[...Array(5).keys()].map((_, j) => (
            <rect
              className={classes.rect}
              key={j}
              x={pos}
              y={
                height / 2 -
                (j + 1) * (barHeight + heightPadding) +
                heightPadding
              }
              width={barWidth}
              height={barHeight}
              fill={topColor}
              style={{
                opacity: j + 1 <= topBars ? 1 : 0,
              }}
            />
          ))}
        </g>
      ))}
      {x.map(({ pos, bottomBars }, i) => (
        <g className="bottom" key={i}>
          {[...Array(5).keys()].map((_, j) => (
            <rect
              className={classes.rect}
              key={j}
              x={pos}
              y={
                height / 2 +
                (j + 1) * (barHeight + heightPadding) -
                2 * heightPadding
              }
              width={barWidth}
              height={barHeight}
              fill={bottomColor}
              style={{
                opacity: j + 1 <= bottomBars ? 1 : 0,
              }}
            />
          ))}
        </g>
      ))}
    </svg>
  )
}

export default withStyles(styles)(BarViz)
